import { render, staticRenderFns } from "./img_hotzone.vue?vue&type=template&id=2a85a63a&scoped=true"
import script from "./img_hotzone.vue?vue&type=script&lang=js"
export * from "./img_hotzone.vue?vue&type=script&lang=js"
import style0 from "./img_hotzone.vue?vue&type=style&index=0&id=2a85a63a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a85a63a",
  null
  
)

export default component.exports